import {
  TRANSACTION_REQUEST_STATUS,
  TransactionRequestDetails,
} from '@/types/transactionRequests';
import { SVSummaryCard } from '../core';
import { SVSummaryCardItem } from '@/types/common';
import { Typography } from '@mui/material';
import { formatDateTimeFromUTC } from '@/utils/date';

type TransactionRequestDetailsCardProps = {
  transactionRequestDetails: TransactionRequestDetails;
};

export default function TransactionRequestDetailsCard({
  transactionRequestDetails,
}: TransactionRequestDetailsCardProps) {
  const {
    status,
    approvedAt,
    approvedBy,
    canceledBy,
    canceledAt,
    declinedBy,
    declinedAt,
    requestedBy,
    requestedAt,
  } = transactionRequestDetails;

  function generateStatusLabel(status: TRANSACTION_REQUEST_STATUS) {
    switch (status) {
      case TRANSACTION_REQUEST_STATUS.Approved:
        return 'Approved';
      case TRANSACTION_REQUEST_STATUS.Canceled:
        return 'Canceled';
      case TRANSACTION_REQUEST_STATUS.Declined:
        return 'Declined';
      case TRANSACTION_REQUEST_STATUS.Expired:
        return 'Expired';
      case TRANSACTION_REQUEST_STATUS.Pending:
        return 'Pending';
      default:
        return 'Under Review';
    }
  }

  const items: SVSummaryCardItem[] = [
    {
      label: 'Status',
      customContent: (
        <Typography
          sx={{
            fontWeight: 'bold',
            color:
              status === TRANSACTION_REQUEST_STATUS.Approved
                ? 'success.main'
                : status === TRANSACTION_REQUEST_STATUS.UnderReview ||
                    status === TRANSACTION_REQUEST_STATUS.Pending
                  ? 'grey'
                  : 'error.main',
          }}>
          {generateStatusLabel(status)}
        </Typography>
      ),
    },
    {
      label: 'Created By',
      text: `${requestedBy.userName} (${requestedBy.userEmail})`,
    },
    {
      label: 'Created Date',
      text: formatDateTimeFromUTC(requestedAt, true),
    },
    {
      label: 'Approved By',
      text: approvedBy
        ? `${approvedBy.userName} (${approvedBy.userEmail})`
        : '',
    },
    {
      label: 'Approved At',
      text: formatDateTimeFromUTC(approvedAt, true),
    },
    {
      label: 'Declined By',
      text: declinedBy
        ? `${declinedBy.userName} (${declinedBy.userEmail})`
        : '',
    },
    {
      label: 'Declined At',
      text: formatDateTimeFromUTC(declinedAt, true),
    },
    {
      label: 'Canceled By',
      text: canceledBy
        ? `${canceledBy.userName} (${canceledBy.userEmail})`
        : '',
    },
    {
      label: 'Canceled At',
      text: formatDateTimeFromUTC(canceledAt, true),
    },
  ];

  return <SVSummaryCard label="Request Details" items={items} />;
}
